import { useMemo } from 'react'

type Helpers = {
  label: (item: any) => string
  value: (item: any) => string | number
}

export default function useSelectOptions(items: any[], helpers: Helpers) {
  return useMemo<{ [key: string]: string | number }>(() => {
    if (items == null) {
      return {}
    }

    const entries = items
      .sort((a: any, b: any) => (a.companyName > b.companyName ? 1 : -1))
      .map((client: any) => {
        // console.log('client: ', client)
        return [helpers.value(client), helpers.label(client).toUpperCase()]
      })

    // console.log('entries: ', entries)

    return Object.fromEntries(entries)
  }, [items])
}
